import React, { ComponentProps } from 'react';
import { ProfileImage } from '../../../types/api/ImageType';
import { asFetchableView, useViewContext } from '../../../_lib/ViewFetcher';
import { Image } from '../../../components/molecules/Image';

type ProfileImageDefaultProps = {
  image: ProfileImage;
};
export function ProfileImageDefault({ image }: ProfileImageDefaultProps) {
  const { fetchUrl } = useViewContext();
  // key denotes a different image, e.g when deleting an image
  return <Image key={image.src} image={image} responsiveType="userProfile" lazyLoading fetchUrl={fetchUrl} />;
}
export const ProfileImageDefaultView = asFetchableView(ProfileImageDefault);
export type ProfileImageDefaultView = ComponentProps<typeof ProfileImageDefaultView>;
